<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  name: 'BarChart',
  props: ['xAxisLabel', 'yAxisLabel', 'xTicks', 'yTicks'],
  mounted () {
    const { chartData, xAxisLabel, yAxisLabel, xTicks, yTicks } = this

    this.renderChart(chartData, {
      responsive: true,
      maintainAspectRatio: false, // 비율에 사이즈조절 width 값이 커지면 height 도 그만큼 늘어남...
      legend: {
        display: false
      },
      scales: {
        xAxes: [Object.assign({
          display: true,
          scaleLabel: {
            display: true,
            labelString: xAxisLabel
          }
        }, (xTicks ? {ticks: xTicks} : null))],
        yAxes: [Object.assign({
          display: true,
          scaleLabel: {
            display: true,
            labelString: yAxisLabel
          }
        }, (yTicks ? {ticks: yTicks} : null))]
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chart/BarChart.vue